import { createContext } from 'react';

import { noop } from '@/_shared';

import { type QuickAddMenuContextType } from './model';

export const QuickAddMenuContext = createContext<QuickAddMenuContextType>({
  activeAction: null,
  metadata: null,
  showModal: noop,
  hideModal: noop,
  filteredQuickActions: [],
});
